import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { MapService } from 'src/app/Service/map.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import axios from 'src/app/Service/axios';
import * as XLSX from 'xlsx';
import moment from 'moment-jalaali';
declare let $: any;

@Component({

  selector: 'app-taxi-manage-vecation',

  templateUrl: './taxi-manage-vecation.component.html',

  styleUrls: ['./taxi-manage-vecation.component.css']

})

export class TaxiManageVecationComponent implements OnInit {

  lst_Vacations: any[] = [];

  lst_Search: any[] = [];

  mdl_Search: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    strFamily: new FormControl(''),

    strMobile: new FormControl(''),

    tiAvtive: new FormControl(-1),

  })

  mdl_Request: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

  })

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

    private _mapService: MapService

  ) { }

  ngOnInit(): void {

    this.get_Vacations();

  }

  filter_list(val: any) {

    this.lst_Vacations = this.lst_Search.filter((el: any) => {

      return el?.strFullName?.includes(val.value) ||

        el.strTaxiLine.includes(val.value) ||

        el.iTaxi_Vacation.toString().startsWith(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Vacations = this.lst_Search;

    }

  }

  async get_Vacations() {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`Taxi_Vacation_List`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Vacations = res;

    this.lst_Search = res;

  }

  async view_Details(item: Record<string, any>) {

    item.tiStatus = item.tiStatus.toString();

    this.mdl_Request.enable();

    Object.keys(item).forEach(key => {

      if (this.mdl_Request.contains(key)) {

        this.mdl_Request.get(key)?.setValue(item[key]);

      }

      else {

        this.mdl_Request.addControl(key, new FormControl(item[key]));

      }

    })

    this.mdl_Request.disable();

    $('#vacation_modal').modal('show');

  }

  async Approve_Reject(item, status) {

    const endDate = moment(item.strEDate, 'jYYYY/jMM/jDD');

    const today = moment();

    // اگر تاریخ پایان مرخصی تمام شده است

    if (endDate.isBefore(today, 'day')) {

      return this._tooltip.showError('تاریخ مرخصی گذشته است');

    }

    // اگر تاریخ پایان مرخصی نرسیده باشد

    $.confirm({

      title: `آیا از انجام این عملیات اطمینان دارید ؟`,

      content: '',

      type: 'blue',

      buttons: {

        ok: {

          text: "تایید",

          btnClass: 'btn-primary',

          keys: ['enter'],

          action: async () => {

            var model = {

              strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

              iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

              iTaxi_Vacation: item.iTaxi_Vacation,

              tiStatus: status

            }

            const resp = await axios.post(`Taxi_Vacation_Approve_Reject`, this._otherService.stringNumberToNumber(model));

            let resParse = JSON.parse(resp.data);

            if (resParse.iResult == 0) return this._tooltip.showError(resParse.strError);

            if (resParse.ISSessionExpired == true) {

              this._tooltip.showError('لطفا وارد سیستم شوید');

              this._otherService.removeLocalStorage();

              this.router.navigate(['login']);

              return;
            }

            else {

              const index = this.lst_Vacations.findIndex(v => v.iTaxi_Vacation === item.iTaxi_Vacation);

              if (index != -1) {

                this.lst_Vacations[index] = resParse[0];

              }

              this._tooltip.showSuccess("عملیات با موفقیت انجام شد");

              $('#vacation_modal').modal('hide');

            }

          }

        },

        cancel: {

          text: "لغو",

        }
      }

    });

  }

  exportExcel() {

    setTimeout(() => {

      let element = document.getElementById('Export_Excel');

      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

      const wb: XLSX.WorkBook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      XLSX.writeFile(wb, 'مدیریت مرخصی ها.xlsx');

    }, 200);

  }

}
